module.exports = __webpack_public_path__ + "static/media/border-inner.85c50262.svg";